import { AuthenticatedShell } from "../components/authenticated-shell"
import { NotFoundContent } from "./not-found-content"

/**
 * Authenticated NotFound page — rendered by the `*` catch-all so an own-origin
 * URL with no matching route (incl. a COLD direct-open) degrades gracefully
 * in-app instead of a blank screen. NOT imported by any Jest test (the shell
 * reaches import.meta); the testable content lives in not-found-content.tsx.
 */
export function NotFoundPage() {
	return (
		<AuthenticatedShell>
			<NotFoundContent />
		</AuthenticatedShell>
	)
}
